export default {"src":"/_next/static/media/Zen IT.af4cff91.svg","height":312,"width":313,"blurWidth":0,"blurHeight":0};